import { useMutation, useQuery } from "react-query";
import { approveRequest, fetchRequests, fetchRequestTypes, raiseRequest, rejectRequest } from "../apis/requests";

const queryOpts = { refetchOnWindowFocus: false };

export const useRequestTypes = () =>
  useQuery(["request_types"], fetchRequestTypes, {
    ...queryOpts,
    select: (res) => res?.data?.data || [],
  });

export const useInboxRequests = ({ pageNum, pageSize, stage }) =>
  useQuery(
    ["request_inbox", pageNum, pageSize, stage],
    () => fetchRequests(pageNum, pageSize, stage),
    {
      ...queryOpts,
      select: (res) => ({
        requests: res?.data?.data || [],
        totalCount: res?.data?.totalCount || 0,
      }),
    }
  );

export const useApproveRequest = (onSuccess, onError) =>
  useMutation(approveRequest, { onSuccess, onError });

export const useRejectRequest = (onSuccess, onError) =>
  useMutation(rejectRequest, { onSuccess, onError });

export const useRaiseRequest = (onSuccess, onError) =>
  useMutation(raiseRequest, { onSuccess, onError });
